// import { startCase } from '@tmhcc/util';
import { startCase } from './lodash-index';

export const JoinArgs = (args: string[] | string, format = false): string => {
  if (Array.isArray(args)) {
    const decorator = format ? ', ' : ',';
    return args.join(decorator);
  }

  return args;
};

export const ReplaceAt = (
  input: string,
  index: number,
  length: number,
  newStr: string
): string => {
  if (index > input.length - 1) {
    return newStr;
  }
  return input.substr(0, index) + newStr + input.substr(index + length);
};

export const FixedString = (input: string): string => {
  return input.replace(/\s/g, '').toUpperCase();
};

export function convertToProperCase(s: string) {
  return startCase(s);
}

export function getBaseUrl(url: string) {
  if (!url || '') return '';
  var pathArray = url.split('/');
  if (pathArray && pathArray.length > 1) {
    var protocol = pathArray[0];
    var host = pathArray[2];
    return protocol + '//' + host;
  }
  return '';
}

export const getBaseUri = (): string => {
  return window.location.origin;
};

export function appendRelativePathToUrl(url: string, pathToAppend: string) {
  if (!pathToAppend) {
    return url;
  }

  if (pathToAppend.toString().indexOf('/') === 0) {
    pathToAppend = pathToAppend.toString().substr(1);
  }

  if (!url || url.length < 1 || '') {
    return pathToAppend;
  }

  if (url.lastIndexOf('/') !== -1 && url.lastIndexOf('/') === url.length - 1) {
    return `${url}${pathToAppend}`;
  }

  return `${url}/${pathToAppend}`;
}
